class CartNotificationNavbar extends HTMLElement {
  constructor() {
    super();
    this.isVisible = false;
    this.setupEventListeners();
  }

  setupEventListeners() {
    const cartNotificationNavbar = document.querySelector('#cart-notification-navbar');    
    // Close button
    const closeButton = this.querySelector('.cart-close-button');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.hide());
      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          this.hide();
        }
      });
    }
  }
  

  show() {
    this.style.display = 'block';
    // Force reflow
    this.offsetHeight;
    this.classList.add('show');
    this.isVisible = true;
    
    // Focus management
    const cart = this.querySelector('.cart-content');
    if (cart) {
        cart.focus();
    }
  }

  hide() {
    this.classList.remove('show');
    this.isVisible = false;
    
    // Hide after animation
    setTimeout(() => {
      if (!this.isVisible) {
        this.style.display = 'none';
      }
    }, 300);
  }
}

customElements.define('cart-notification-navbar', CartNotificationNavbar);